import { Immutable } from "immer";
import React, { useContext } from "react";
import { t } from "ttag";

import { Context } from "@reactivated";

import { IntrinsicElementProps } from "@thelabnyc/thelabui/src/utils/types";

import { FinancingCardType } from "../../../constants";
import { getReactivatedContext } from "../../../utils/environment";

const iconPaths: { [K in FinancingCardType]: string } = {
    [FinancingCardType.TEMPUR_CC]: "img/finance/tempur-cc-updated.png",
    [FinancingCardType.STEARNS_CC]: "img/finance/stearns-cc.png",
    [FinancingCardType.SEALY_CC]: "img/finance/sealy-cc-updated.png",
    [FinancingCardType.COCOON_CC]: "img/finance/cocoon-cc.png",
};

type PassthroughProps = Omit<IntrinsicElementProps<HTMLImageElement>, "src">;
type Props = Immutable<{
    cardType: FinancingCardType;
}> & {
    ref?: React.Ref<HTMLImageElement>;
} & PassthroughProps;

export const FinancingCardImage = (props: Props): React.JSX.Element => {
    const context = useContext(Context) || getReactivatedContext();
    const { cardType, ref, ...otherProps } = props;
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    const staticURL = context?.STATIC_URL ?? "/static/";
    const src = `${staticURL}${iconPaths[cardType]}`;
    return (
        <img ref={ref} src={src} alt={t`Credit Card image`} {...otherProps} />
    );
};
